// extracted by mini-css-extract-plugin
module.exports = {"container":"entity_keywords-module__container--3QA5u"};